import React from "react";
import SCSMSDashboard from "./SCSMSDashboard";
import type { DashboardPageProps } from "./dashboard.types";

export default function ExecutiveDashboard(props: DashboardPageProps) {
  return (
    <SCSMSDashboard
      {...props}
      dashboard="executive"
      title="Executive Dashboard"
      subtitle="Sales, receivables, stock, approvals, and cutting workload at a glance."
    />
  );
}
